import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, CalendarDays } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function EventClaimPage() {
  const { eventoId } = useParams();
  const [searchParams] = useSearchParams();
  const person = searchParams.get("person") || "";
  const token = searchParams.get("token") || "";
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const [eventoName, setEventoName] = useState("");
  const claimedRef = useRef(false);

  useEffect(() => {
    if (claimedRef.current) return;
    claimedRef.current = true;
    const claim = async () => {
      try {
        const res = await fetch(`${API}/api/public/eventos/${eventoId}/claim`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ person, token }),
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok) {
          setStatus(data.success ? "success" : "already_covered");
          setMessage(data.message || "");
          setEventoName(data.evento_name || "");
        } else {
          setStatus("error");
          setMessage(data.detail || "No se pudo reclamar el evento.");
        }
      } catch {
        setStatus("error");
        setMessage("Error de conexión. Inténtalo de nuevo o revisa /eventos.");
      }
    };
    if (eventoId && person && token) claim();
    else { setStatus("error"); setMessage("Link incompleto."); }
  }, [eventoId, person, token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/40 p-4" data-testid="event-claim-page">
      <div className="max-w-md w-full bg-background rounded-xl border shadow-sm p-8 text-center space-y-4">
        <CalendarDays className="w-10 h-10 mx-auto text-primary" />
        {status === "loading" && (
          <>
            <Loader2 className="w-8 h-8 mx-auto animate-spin text-muted-foreground" />
            <p className="text-sm text-muted-foreground" data-testid="claim-status-loading">Reclamando evento...</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-500" />
            <h1 className="text-lg font-semibold" data-testid="claim-status-success">¡Cobertura confirmada!</h1>
            <p className="text-sm text-muted-foreground">{message}</p>
          </>
        )}
        {status === "already_covered" && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-amber-500" />
            <h1 className="text-lg font-semibold" data-testid="claim-status-already-covered">Ya cubierto</h1>
            <p className="text-sm text-muted-foreground">{message}</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-red-500" />
            <h1 className="text-lg font-semibold" data-testid="claim-status-error">No se pudo completar</h1>
            <p className="text-sm text-muted-foreground">{message}</p>
          </>
        )}
        {eventoName && <p className="text-sm font-medium">{eventoName}</p>}
        <Link to="/eventos" className="text-sm text-primary underline" data-testid="claim-go-to-eventos">Ir a Eventos Innovación</Link>
      </div>
    </div>
  );
}
